import { useTranslation } from 'react-i18next';
import { humanizeEnum } from '@/lib/utils';
import { Money, Row, SourceRow, day } from './bodyParts';

export interface ChequeDetail {
  id: string;
  chequeNo: string;
  status: string;
  type: string;
  amount: number | string;
  bankName: string;
  drawerName?: string | null;
  chequeDate: string;
  dueDate?: string | null;
  notes?: string | null;
  customer?: { name: string } | null;
  supplier?: { name: string } | null;
  bankAccount?: { name: string } | null;
  sale?: { id: string; invoiceNumber: string } | null;
}

/** Read-only cheque for the record viewer (POS-I239); the invoice it came from is a link. */
export function ChequeDetailBody({ data }: { data: ChequeDetail }) {
  const { t } = useTranslation('records');
  const party = data.customer?.name ?? data.supplier?.name;
  return (
    <div className="space-y-5 text-sm">
      <dl className="space-y-1.5">
        <Row label={t('rvChequeType')}>{humanizeEnum(data.type)}</Row>
        <Row label={t('rvAmount')}><Money value={data.amount} /></Row>
        <Row label={t('rvBank')}>{data.bankName}</Row>
        {data.drawerName && <Row label={t('rvDrawer')}>{data.drawerName}</Row>}
        {party && <Row label={data.customer ? t('rvCustomer') : t('rvSupplier')}>{party}</Row>}
        <Row label={t('rvChequeDate')}><span dir="ltr">{day(data.chequeDate)}</span></Row>
        {data.dueDate && <Row label={t('rvDueDate')}><span dir="ltr">{day(data.dueDate)}</span></Row>}
        {data.bankAccount?.name && <Row label={t('rvBankAccount')}>{data.bankAccount.name}</Row>}
        {data.notes && <Row label={t('rvNotes')}>{data.notes}</Row>}
      </dl>
      <SourceRow
        items={[
          {
            label: t('rvInvoice'),
            source: data.sale ? { type: 'invoice', id: data.sale.id, label: data.sale.invoiceNumber } : null,
          },
        ]}
      />
    </div>
  );
}
